import {_getGlobalState} from "mobx";
import {useStores} from "~/stores";
import type {m_taxonomy} from "~/services/classes/TaxonomyClasses";
import {ApprovalStatusEnum} from "~/services/classes/AiClasses";
import {isUnderConstructionMode} from "~/utils/underConstructionMode";

/**
 * Whether the user may edit this taxonomy: the current builder's rules (`canEditTaxonomy`), plus
 * read-only accounts never can. Editing waits while an approval request is open.
 * Throws when called from a component that is not an `observer` — those reads would not update.
 */
export function useCanEditTaxonomy(taxonomy: m_taxonomy.FullSerializer | undefined): boolean {
    if (!_getGlobalState().trackingDerivation) {
        throw new Error("useCanEditTaxonomy must be called from an observer component");
    }

    const {authStore, p} = useStores();
    if (!taxonomy || isUnderConstructionMode(authStore)) return false;
    if (authStore.isMithraStaffGroup) return true;
    if (!authStore.hasEditPermission || p.p.taxonomyBuilderViewOnly) return false;

    const status = taxonomy.active_approval_request?.current_status.status;
    return status === undefined || status === ApprovalStatusEnum.APPROVED || status === ApprovalStatusEnum.REJECTED;
}
